package net.bothosting.docs.pages.faqs_and_info

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initIssues_creating_server_free_usersPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("faqs_and_info/issues_creating_server_free_users.md", FrontMatterElement.Builder { addScalar("description", "Known issues about server creation"); }))
}

@Page("/faqs_and_info/issues-creating-server-free-users")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Issues_creating_server_free_usersPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("issues-creating-server-free-users") }) {
        org.jetbrains.compose.web.dom.Text("Issues Creating Server [Free Users]")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Some ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("common errors")
        }
        org.jetbrains.compose.web.dom.Text(" are:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("Creating server...")
            }
            org.jetbrains.compose.web.dom.Text(" (stuck with this message)")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("Server Creation Timed out whilst in queue. Please try again.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("An unknown error occurred creating your server!")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("There is not currently enough capacity to deploy your server.")
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("All of these errors are related to our free server nodes being full. You have two ways to \"fix\" them:")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Wait patiently and keep trying")
            }
            org.jetbrains.compose.web.dom.Text(" to create the server.")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Servers are constantly created and deleted")
            }
            org.jetbrains.compose.web.dom.Text(": when there is enough capacity available, you will be able to create a server.")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("These messages may appear from time to time, and ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("we cannot give an ETA")
            }
            org.jetbrains.compose.web.dom.Text(" for when you will be able to create a server.")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("You can try to use ")
            com.varabyte.kobweb.silk.components.navigation.Link("/community_resources/bananaburner-panel") {
                org.jetbrains.compose.web.dom.Text("bananaburner-panel.md")
            }
            org.jetbrains.compose.web.dom.Text(" tool to automatically retry server creation. The linked post has a guide on how to install and use the extension.")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("Please do ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("not")
            }
            org.jetbrains.compose.web.dom.Text(" open new tickets about these messages. You will simply be redirected here, and the ticket will be closed.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Buy a coin package that includes Premium Node access (${'$'}3 or higher). See ")
            com.varabyte.kobweb.silk.components.navigation.Link("/faqs_and_info/premium-support-and-nodes") {
                org.jetbrains.compose.web.dom.Text("Premium Support & Nodes")
            }
            org.jetbrains.compose.web.dom.Text(" and ")
            com.varabyte.kobweb.silk.components.navigation.Link("/faqs_and_info/payment-guide") {
                org.jetbrains.compose.web.dom.Text("Payment Guide")
            }
            org.jetbrains.compose.web.dom.Text(".")
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" There are no plans to add new free server nodes. We already host more than 20k free servers, and the machines they run on cost money.")
        }
    }
}
